module.exports = __webpack_public_path__ + "img/photo-15.8b8aaaa5.png";